<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps<{
  disabled?: boolean
  sending?: boolean
}>()

const isDisabled = computed(() => props.disabled || props.sending)
</script>

<template>
  <button :disabled="isDisabled" type="button">
    <div
      class="py-2 px-4 flex flex-row items-center gap-2 rounded-lg bg-new-primary-default text-white uppercase tracking-widest"
      :class="{
        'hover:bg-new-primary-hover': !isDisabled,
        'cursor-not-allowed opacity-25': isDisabled,
      }"
    >
      <template v-if="sending">
        <i class="fa-solid fa-spinner animate-spin"></i>
        <span>{{ $t('assistant.chat.actions.sending') }}</span>
      </template>
      <template v-else>
        <span>{{ $t('assistant.chat.actions.send') }}</span>
      </template>
    </div>
  </button>
</template>
